import { render, staticRenderFns } from "./Colom.vue?vue&type=template&id=83a5afcc&scoped=true&"
import script from "./Colom.vue?vue&type=script&lang=js&"
export * from "./Colom.vue?vue&type=script&lang=js&"
import style0 from "./Colom.vue?vue&type=style&index=0&id=83a5afcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a5afcc",
  null
  
)

export default component.exports